import { mediaMax } from '@/app/styles/breakpoints'
import { Flex } from 'antd'
import styled, { css } from 'styled-components'

export const PartnersGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 32px;
  width: 100%;

  ${mediaMax.lg} {
    grid-template-columns: repeat(3, 1fr);
  }

  ${mediaMax.md} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaMax.sm} {
    grid-template-columns: 1fr;
    gap: 16px;
  }
`

export const PartnerCard = styled(Flex)<{ $isSelected?: boolean }>`
  border-radius: 6px;
  padding: 16px;
  background: ${(props) =>
    props.$isSelected
      ? props.theme.colors.subpartners.selected
      : props.theme.colors.grayBackground};
  cursor: pointer;
  transition: all 0.3s ease;
  height: 88px;
  box-shadow: ${(props) =>
    props.$isSelected ? '0 6px 12px 0 rgba(66, 74, 83, 0.12)' : 'none'};

  ${(props) =>
    !props.$isSelected &&
    css`
      &:hover {
        background: ${props.theme.colors.subpartners.hover};
        box-shadow: 0 6px 12px 0 rgba(66, 74, 83, 0.12);
      }
    `}
`

export const PartnerName = styled.div`
  font-weight: 600;
`

export const PartnerId = styled.span`
  color: ${(props) => props.theme.colors.cardDescription};
`

export const PaginationContainer = styled(Flex)`
  && {
    .ant-pagination-prev,
    .ant-pagination-next {
      padding: 0 12px;
    }
    svg {
      fill: currentColor;
    }
    .ant-pagination-disabled {
      opacity: 0.25;
    }
    li:not(.ant-pagination-disabled) {
      color: ${(props) => props.theme.colors.primary};
    }
    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.colors.primary};
      a {
        color: white;
      }
    }
    .ant-pagination-item:not(.ant-pagination-item-active) {
      ${mediaMax.sm} {
        display: none;
      }
    }
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev,
    .ant-pagination-jump-next + .ant-pagination-item {
      ${mediaMax.md} {
        display: none;
      }
    }
  }
`

export const PagerButton = styled(Flex)``
